'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_Symbol(name) {
  this.wt = null;
  this.wt = name;
}
export { $c_s_Symbol as $c_s_Symbol };
$p = $c_s_Symbol.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_Symbol;
/** @constructor */
function $h_s_Symbol() {
}
export { $h_s_Symbol as $h_s_Symbol };
$h_s_Symbol.prototype = $p;
$p.b = (function() {
  return (("Symbol(" + this.wt) + ")");
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$f_T__hashCode__I(this.wt);
});
$p.f = (function(other) {
  return (this === other);
});
var $d_s_Symbol = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_Symbol, "scala.Symbol", ({
  s3: 1,
  a: 1
}));
export { $d_s_Symbol as $d_s_Symbol };
